import i18n from '@/locale/index';
export let Config = {
        pieOptions:{
            tooltip: {
                trigger: 'item'
            },
            color:['#4992FF', '#2DD574', '#FF6E76','#F7D221'],
            tooltip : {
                show: true,
                formatter: "{a}<br/>{b} "
                // formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            series: [
                {
                    name: i18n.t('components.dataPie.796669-0'),
                    type: 'pie',
                    radius: ['40%', '80%'],
                    center: ['50%', '40%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '13',
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: [
                        // {value: 1048, name: '语文'},
                        // {value: 735, name: '英语'},
                        // {value: 580, name: '数学'},
                        // {value: 484, name: '其他'},
                    ]
                }
            ],
            legend: {
                bottom:'5%',
                itemWidth:30,
                textStyle:{
                    color:'#000',
                },
            },
        },
    // }
};
export function showWork(arr=[]) {//修改获奖作品效果
    Config.pieOptions.series[0].data=arr;
}